module.exports = __webpack_public_path__ + "img/Proliferation-INCA_10X_IC.5e2cfae2.png";